import React from 'react';

const pastelColors = {
    green: { border: '#81C784', color: '#2E7D32', bg: '#E8F5E9' },
    yellow: { border: '#FFD54F', color: '#F57F17', bg: '#FFF8E1' },
    red: { border: '#E57373', color: '#C62828', bg: '#FFEBEE' },
};

const chipStyle = {
    display: 'flex',
    height: '20px',
    padding: '0px 12px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    borderRadius: '20px',
    background: '#75C422',
    color: '#333',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
};

/**
 * 
 * @param {{
 * label: string,
 * style: React.CSSProperties,
 * variant: 'filled' | 'outlined',
 * color: 'green' | 'yellow' | 'red',
 * }} param0 
 * @returns 
 */
const BasicChip = ({ label, style = {}, variant = 'filled', color }) => {
    let resolvedStyle = { ...chipStyle, ...style };

    if (variant === 'outlined' && color && pastelColors[color]) {
        const palette = pastelColors[color];
        resolvedStyle = {
            ...resolvedStyle,
            background: palette.bg,
            color: palette.color,
            border: `1px solid ${palette.border}`,
            fontWeight: '500',
            cursor: 'pointer',
        };
    }

    return (
        <span style={resolvedStyle}>
            {label}
        </span>
    );
};

export default BasicChip;



// WEBPACK FOOTER //
// ./app/components/Base/Chips/BasicChip.jsx